import { language } from "shared/language";

export const UTILITY_NOT_FOUND = language.utility_not_found;
export const UTILITY_PARTNER_NOT_FOUND = language.utility_partner_not_found;
export const UTILITY_CODE_EXISTED = language.utility_code_existed;
export const UTILITY_PARTNER_PHONE_EXISTED =
  language.utility_partner_phone_existed;
export const UTILITY_PARTNER_CANNOT_BE_DELETED =
  language.utility_partner_cannot_be_deleted;
